module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"artist-educators\"-in-inglewood-california-ebf4d775d189fb4efc6f5e8a02f1927a.png";